<template>
  <div :class="$style.actionSidebarAvatarItemWrapper">
    <button
      :class="$style.actionSidebarAvatarItem"
      @click="$emit('click')"
    >
      <AddRounded
        v-if="custom && !src"
        :class="$style.actionSidebarAvatarItemIcon"
      />
      <Component
        :is="src === null ? 'div' : 'img'"
        v-else
        :src="src"
        alt=""
        :class="$style.actionSidebarAvatarItemImage"
      />

      <div
        v-if="isActive"
        :class="$style.actionSidebarAvatarItemIsActive"
      >
        <CheckRounded :class="$style.actionSidebarAvatarItemIcon" />
      </div>
    </button>

    <button
      v-if="custom && src"
      :class="$style.actionSidebarAvatarItemRemove"
      @click="$emit('handleRemove')"
    >
      <DeleteOutlineRounded :class="$style.actionSidebarAvatarItemRemoveIcon" />
    </button>
  </div>
</template>

<script>
import AddRounded from '@/assets/icons/AddRounded.svg?inline'
import CheckRounded from '@/assets/icons/CheckRounded.svg?inline'
import DeleteOutlineRounded from '@/assets/icons/DeleteOutlineRounded.svg?inline'

export default {
  components: {
    AddRounded,
    CheckRounded,
    DeleteOutlineRounded
  },
  props: {
    src: {
      type: String,
      default: null
    },
    custom: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style module lang="scss">
.actionSidebarAvatarItemWrapper {
  position: relative;
}

.actionSidebarAvatarItemRemove {
  --s: 24px;

  all: unset;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: var(--s);
  height: var(--s);
  color: var(--white);
  background-color: var(--main-red);
  cursor: pointer;
}

.actionSidebarAvatarItem {
  all: unset;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background-color: var(--blue-shade-8);
  box-shadow: inset 0 0 0 2px var(--blue-shade-8), inset 0 0 0 4px var(--white);
  user-select: none;
  cursor: pointer;
  color: var(--blue-shade-50);
}

.actionSidebarAvatarItemIsActive {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(41, 98, 255, 0.5);
  box-shadow: inset 0 0 0 2px var(--main-blue), inset 0 0 0 4px var(--white);
  cursor: pointer;
  color: var(--white);
}

.actionSidebarAvatarItemImage {
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  object-fit: cover;
  border-radius: 50%;
}

.actionSidebarAvatarItemIcon {
  --s: 24px;

  width: var(--s);
  height: var(--s);
}

.actionSidebarAvatarItemRemoveIcon {
  --s: 16px;

  width: var(--s);
  height: var(--s);
}
</style>
